import { defineStore } from 'pinia';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    loginKey: sessionStorage.getItem('loginKey') || '',
    showTopUpCount: 0, //显示登录弹窗版本
  }),
  actions: {
    setLoginKey(key: any, triggerLoginDialog = true) {
      this.loginKey = key;
      // 退出登录时可静默清理，避免误触发全局登录弹窗。
      if (triggerLoginDialog) {
        let count = this.showTopUpCount + 1;
        this.showTopUpCount = count;
      }
      if( key == null ){
        key = '';
      }
      sessionStorage.setItem('loginKey', key);
    },
    setShowTopUpCount(showTopUpCount) {
      this.showTopUpCount = showTopUpCount;
    },
    removeLoginKey(triggerLoginDialog = true) {
      this.loginKey = null;
      if (triggerLoginDialog) {
        let count = this.showTopUpCount + 1;
        this.showTopUpCount = count;
      }
      sessionStorage.removeItem('loginKey');
    }
  }
});
